export const Divider = () => {
    return (
        <div className="divider" 
            style={{    
                display: "block",
                backgroundColor: "#ccc",
                height: "1px",
                flexGrow:"0",
                flexShrink:"0",
                marginTop: "0.5rem",
                marginBottom: "0.5rem"
            }} />
    )
}

export const DashedDivider = () => {
    return (
        <div className="dashed-bottom-border" style={{marginTop: '0.5rem', marginBottom: '0.5rem'}}>
        </div>
    )
}